function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* global Wix, publicModel, editorModel  */
import { extractQueryParam } from './url-utils';

function getInterceptor(_ref) {
  var wixCodeApi = _ref.wixCodeApi;

  var requestSuccess = function requestSuccess(config) {
    var shouldAddSiteRevision = config.url.includes('/_api/');

    if (shouldAddSiteRevision) {
      var siteRevision = getSiteRevision(wixCodeApi);

      if (siteRevision) {
        var _objectSpread2;

        var headers = _objectSpread(_objectSpread({}, config.headers), {}, (_objectSpread2 = {}, _objectSpread2[siteRevisionHeader] = siteRevision, _objectSpread2));

        return _objectSpread(_objectSpread({}, config), {}, {
          headers: headers
        });
      }
    }

    return config;
  };

  return {
    requestSuccess: requestSuccess
  };
}

var getSiteRevision = function getSiteRevision(wixCodeApi) {
  if (typeof Wix !== 'undefined' && Wix.Utils && Wix.Utils.getSiteRevision) {
    return Wix.Utils.getSiteRevision();
  }

  var siteRevisionFromQueryParam = getSiteRevisionFromQueryParam();

  if (siteRevisionFromQueryParam) {
    return siteRevisionFromQueryParam;
  }

  if (wixCodeApi) {
    return wixCodeApi.site.revision;
  }

  if (typeof publicModel !== 'undefined' && publicModel.siteRevision) {
    return publicModel.siteRevision;
  }

  if (typeof editorModel !== 'undefined' && editorModel.siteHeader && editorModel.siteHeader.revision) {
    return editorModel.siteHeader.revision;
  }
};

var getSiteRevisionFromQueryParam = function getSiteRevisionFromQueryParam() {
  if (typeof window !== 'undefined' && window.location) {
    return extractQueryParam(window.location, 'siteRevision');
  }
};

export default {
  getInterceptor: getInterceptor
};
export var siteRevisionHeader = 'x-wix-site-revision';